import React from 'react';
import './FullscreenModal.scss';

const FULLSCREEN_WIDTH = '90vw';

const FULLSCREEN_HEIGHT = '70vh';

export const FullscreenModal = ({ children }) => {
  return (
    <div
      id="modal-fullscreen"
      role="dialog"
      tabIndex="-1"
      aria-hidden="true"
      className="modal fade show fullscreen"
    >
      <div
        role="document"
        style={{ width: FULLSCREEN_WIDTH, maxWidth: FULLSCREEN_WIDTH }}
        className="modal-dialog modal-dialog-centered modal__pattern"
      >
        <div className="modal-content">
          <div className="modal-body">
            {React.Children.map(children, child =>
              React.isValidElement(child) ? React.cloneElement(child, { height: FULLSCREEN_HEIGHT }) : child
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
